import React from "react";
import { Table } from "@allxsmith/bestax-bulma";
import VehicleInspectionRow from "./VehicleInspectionRow";

export default function Inspections({vehicle, onInspectionAdd, attached_inspections, type}) {

  return (
      <Table isBordered>
        <thead>
        <tr>
          <th className={"table-header-bold"}>Inspection Type</th>
          <th className={"table-header-bold"}>Inspection Workshop</th>
          <th className={"table-header-bold"}>Expiry Date</th>
          <th className={"table-header-bold"}></th>
        </tr>
        </thead>
        <tbody>
        {vehicle.inspections && vehicle.inspections.map(inspection => (
            <VehicleInspectionRow
                inspection={inspection}
                onInspectionAdd={onInspectionAdd}
                attached_inspections={attached_inspections}
                type={type}
            />
        ))}
        </tbody>
      </Table>
    );

}